export const SignupInitialValues = {
  fullName: "",
  email: "",
  password: "",
  confirmPassword: "",
};
export const SigninInitialValues = {
  email: "",
  password: "",
};

export const ForgotPasswordInitialValues = {
  email: "",
};
